var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Quill from 'quill';
import ENV from 'config/env';
var embed = Quill.import('blots/embed');
var arrowIcon = require('common/UIToolKit/icons/arrow-right-sml.svg?raw');
var FormLinkEmbed = /** @class */ (function (_super) {
    __extends(FormLinkEmbed, _super);
    function FormLinkEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormLinkEmbed.create = function (options) {
        var node = _super.create.call(this);
        node.innerText = "" + options.text;
        node.setAttribute('href', "" + ENV.APPS.FORM_VIEWER.URL + options.formUuid);
        node.classList.add('text-white', 'bg-company-btn', 'rounded');
        var icon = document.createElement('span');
        icon.innerHTML = arrowIcon;
        icon.classList.add('icon', 'text-size-3');
        node.appendChild(icon);
        return node;
    };
    FormLinkEmbed.blotName = 'FormLinkEmbed';
    FormLinkEmbed.className = 'form-button';
    FormLinkEmbed.tagName = 'a';
    return FormLinkEmbed;
}(embed));
export { FormLinkEmbed };
